
import "../Foundation/stylable/colors.st.css.js";
import "../common/Focusable/Focusable.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_Checkbox";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_Checkbox__root","label":"wds_1_76_1_Checkbox__label","labelInner":"wds_1_76_1_Checkbox__labelInner","children":"wds_1_76_1_Checkbox__children","checkbox":"wds_1_76_1_Checkbox__checkbox","inner":"wds_1_76_1_Checkbox__inner","outer":"wds_1_76_1_Checkbox__outer"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




